// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"32":"e7528415","97":"5f0b08d5","423":"b972d0ed"}[chunkId] + ".chunk.css";
};